import { z } from "zod";
import { SWMetadata } from "./base";
import { CachePurge_Request } from "./cache";
import { Chatops_Request } from "./chatops";
import { Cron_Complete, Cron_Fail, Cron_Heartbeat, Cront_Start } from "./cron";
import { Deployment_Boot, Deployment_Complete, Deployment_Fail, Deployment_Start } from "./deployment";
import { EventParsing_Fail } from "./eventParsing";
import { PaywallPreviewGeneration_Complete, PaywallPreviewGeneration_Start } from "./paywallPreview";
import { PJSDivCheck_Complete } from "./pjs";
import { DashboardClickhouseQuery_Complete, DashboardClickhouseQuery_Start } from "./query";
import { SmokeTest_Complete, SmokeTest_Fail, SmokeTest_Heartbeat, SmokeTest_Start } from "./smoke";
import { StaticConfigCache_Invalid } from "./staticConfig";
import { Test_Action } from "./test";
export const SWEvent = z.discriminatedUnion("name", [
    EventParsing_Fail,
    Deployment_Start,
    Deployment_Complete,
    Deployment_Fail,
    Deployment_Boot,
    Chatops_Request,
    CachePurge_Request,
    Cront_Start,
    Cron_Heartbeat,
    Cron_Complete,
    Cron_Fail,
    SmokeTest_Start,
    SmokeTest_Complete,
    SmokeTest_Fail,
    SmokeTest_Heartbeat,
    DashboardClickhouseQuery_Complete,
    DashboardClickhouseQuery_Start,
    Test_Action,
    PaywallPreviewGeneration_Start,
    PaywallPreviewGeneration_Complete,
    StaticConfigCache_Invalid,
    PJSDivCheck_Complete
]);
export { SWMetadata };
